import { Control } from "react-hook-form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { NumberInput } from "@/components/ui/number-input";
import { useI18n } from "@/lib/i18n/hook";
import { useCurrency as useCurrencyContext } from "../contexts/currency-context";

interface InvestmentAssetFormProps {
  control: Control<any>;
  name: string;
  label: string;
}

export function InvestmentAssetForm({
  control,
  name,
  label,
}: InvestmentAssetFormProps) {
  const { t } = useI18n();
  const { currency } = useCurrencyContext();
  return (
    <>
      <FormField
        control={control}
        name={`${name}.amount`}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{label}</FormLabel>
            <div className="flex items-center gap-2">
              <FormControl>
                <NumberInput
                  min={0}
                  value={field.value}
                  onValueChange={(val) => field.onChange(val ?? 0)}
                  ref={field.ref}
                  name={field.name}
                  onBlur={field.onBlur}
                />
              </FormControl>
              <span className="text-sm">{currency}</span>
            </div>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name={`${name}.return`}
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              {t("lifePlan.assetsLiabilities.assets.return")}
            </FormLabel>
            <div className="flex items-center gap-2">
              <FormControl>
                <NumberInput
                  min={-100}
                  max={100}
                  step={0.1}
                  value={field.value}
                  onValueChange={(val) => field.onChange(val ?? 0)}
                  ref={field.ref}
                  name={field.name}
                  onBlur={field.onBlur}
                />
              </FormControl>
              <span className="text-sm">%</span>
            </div>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name={`${name}.volatility`}
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              {t("lifePlan.assetsLiabilities.assets.volatility")}
            </FormLabel>
            <div className="flex items-center gap-2">
              <FormControl>
                <NumberInput
                  min={0}
                  max={100}
                  step={0.1}
                  value={field.value}
                  onValueChange={(val) => field.onChange(val ?? 0)}
                  ref={field.ref}
                  name={field.name}
                  onBlur={field.onBlur}
                />
              </FormControl>
              <span className="text-sm">%</span>
            </div>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
